import { Box, Typography } from '@mui/material'
import { useAuth } from '../contexts/auth-context'
import DeveloperTab from '../components/DeveloperTab'
import { PageContainer } from '../components/PageContainer'

export function DeveloperPage() {
	const { customerId } = useAuth()

	return (
		<PageContainer>
			<Box sx={{ mb: 4 }}>
				<Typography variant="h4" fontWeight="bold" gutterBottom>
					Developer Tools
				</Typography>
				<Typography variant="body1" color="text.secondary">
					API keys, webhooks, and integration documentation
				</Typography>
			</Box>

			<DeveloperTab customerId={customerId} />
		</PageContainer>
	)
}
